import { render, staticRenderFns } from "./ThgProductsPriceCard.vue?vue&type=template&id=2851ed93&scoped=true"
import script from "./ThgProductsPriceCard.vue?vue&type=script&lang=ts"
export * from "./ThgProductsPriceCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgProductsPriceCard.vue?vue&type=style&index=0&id=2851ed93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851ed93",
  null
  
)

export default component.exports